import React from 'react';
import PropTypes from 'prop-types';
import { Markdown } from '@commercetools-docs/ui-kit';
import { Link, BetaFlag } from '@commercetools-docs/gatsby-theme-docs';
import BasicFlag from './basic-flag';
import apiNav from '../../../api/src/data/navigation.yaml';
import importNav from '../../../import-export/src/data/navigation.yaml';

const ignoreChapters = ['General Topics', 'General Concepts', 'Authorization'];
const chaptersWithoutHeading = ['API Specification'];
const ignorePagePaths = [
  '/client-logging',
  '/history/change-types',
  '/projects/custom-fields',
];
const premiumChapterTitles = ['Audit Log'];
const premiumPagePaths = ['/history/change-history'];

const NavList = (props) => {
  return props.navData
    .filter((chapter) => !ignoreChapters.includes(chapter['chapter-title']))
    .map((chapter) => (
      <>
        {!chaptersWithoutHeading.includes(chapter['chapter-title']) ? (
          <Markdown.H3>
            {chapter['chapter-title']}
            {premiumChapterTitles.includes(chapter['chapter-title']) ? (
              <>
                &nbsp;
                <BasicFlag />
              </>
            ) : null}
          </Markdown.H3>
        ) : null}
        <Markdown.Ul>
          {chapter.pages
            .filter((page) => !ignorePagePaths.includes(page.path))
            .map((page) => (
              <Markdown.Li key={page.path}>
                <Link href={'/../' + props.pathPrefix + page.path}>
                  {page.title}
                </Link>
                &nbsp;
                {page.beta || props.allBeta ? <BetaFlag /> : null}
                &nbsp;
                {premiumPagePaths.includes(page.path) ? <BasicFlag /> : null}
              </Markdown.Li>
            ))}
        </Markdown.Ul>
      </>
    ));
};
NavList.propTypes = {
  title: PropTypes.string.isRequired,
  pathPrefix: PropTypes.string.isRequired,
  navData: PropTypes.object.isRequired,
  allBeta: PropTypes.bool,
};

const ApiList = (props) => {
  return (
    <section>
      <NavList title="HTTP API" pathPrefix="api" navData={apiNav}></NavList>
      <Markdown.H3>
        Import API&nbsp;
        <BetaFlag />
      </Markdown.H3>
      <NavList
        title="Import API"
        pathPrefix="import-export"
        navData={importNav}
        allBeta={true}
      ></NavList>
      <Markdown.H3>GraphQL API</Markdown.H3>
      <Markdown.Ul>
        <Markdown.Li>
          <Link href="/../api/graphql">The GraphQL API</Link>
        </Markdown.Li>
      </Markdown.Ul>
    </section>
  );
};
NavList.propTypes = {};

export default ApiList;
